export const explainRegexObject = (input) => {
  try {
    const { pattern, flags } = JSON.parse(input);
    let explanation = "This pattern matches ";

    const anchoredStart = pattern.startsWith('^');
    const anchoredEnd = pattern.endsWith('$');

    let core = pattern;
    if (anchoredStart) {
      explanation += "a string that starts with ";
      core = core.slice(1);
    } else {
      explanation += "any part of the string that contains ";
    }

    if (anchoredEnd) {
      core = core.slice(0, -1);
    }

    // Interpret core
    if (!core) {
      explanation += "nothing";
    } else if (/\(([^)]+)\|([^)]+)\)/.test(core)) {
      const [, opt1, opt2] = core.match(/\(([^)]+)\|([^)]+)\)/);
      explanation += `either "${opt1}" or "${opt2}"`;
    } else if (/\[([^\]]+)\]/.test(core)) {
      const chars = core.match(/\[([^\]]+)\]/)[1];
      explanation += `any one of the characters [${chars}]`;
    } else if (/\\d/.test(core)) {
      explanation += "a digit (0-9)";
    } else if (/\\w/.test(core)) {
      explanation += "a word character (letter, number, or underscore)";
    } else if (/\\s/.test(core)) {
      explanation += "a whitespace character (space, tab, etc.)";
    } else if (/\./.test(core)) {
      explanation += "any single character (except newline)";
    } else {
      const cleaned = core.replace(/\\\\/g, '');
      explanation += `"${cleaned}"`;
    }

    // Quantifiers
    if (/\+\??/.test(core)) {
      explanation += ", one or more times";
    }
    if (/\*\??/.test(core)) {
      explanation += ", zero or more times";
    }
    if (/\?\??/.test(core) && !core.includes("(?")) {
      explanation += ", optionally";
    }
    if (/\{(\d+)(,)?(\d+)?\}/.test(core)) {
      const match = core.match(/\{(\d+)(,)?(\d+)?\}/);
      const min = match[1];
      const comma = match[2];
      const max = match[3];
      if (comma && max) {
        explanation += `, between ${min} and ${max} times`;
      } else if (comma) {
        explanation += `, at least ${min} times`;
      } else {
        explanation += `, exactly ${min} times`;
      }
    }

    if (anchoredEnd) {
      explanation += " and ends there";
    }

    // Flags
    const flagDescriptions = [];
    if (flags.includes('i')) flagDescriptions.push("case-insensitive");
    if (flags.includes('g')) flagDescriptions.push("matching all occurrences");
    if (flags.includes('m')) flagDescriptions.push("multi-line (^ and $ match per line)");
    if (flags.includes('s')) flagDescriptions.push("dot (.) matches newlines");

    if (flagDescriptions.length > 0) {
      explanation += " (" + flagDescriptions.join(", ") + ")";
    }

    return explanation + ".";
  } catch (err) {

  }
  
}



export const isValidRegexObject = (input) => {
  try {
    const { pattern, flags } = JSON.parse(input);

    // Basic structure check
    if (typeof pattern !== 'string') throw new Error('Missing or invalid pattern');

    // Validate by constructing a RegExp
    new RegExp(pattern, flags || '');
    return true;

  } catch (err) {
    return false;
  }
}